import React, { useEffect, useState } from "react";
import styles from "./style.scss";
import { OutlineButton as Button } from "components/Common/Button/Outline";
import NotificationToast from "features/NotificationToast";

interface Props {
  onClick: () => void;
  disabled: boolean;
}

export const CopyButton: React.FC<Props> = ({ onClick, disabled }) => {
  const [showNotification, setShowNotification] = useState(false);

  const handleCopy = () => {
    setShowNotification(true);
    onClick();
  };

  useEffect(() => {
    if (!showNotification) return;

    const timer = setTimeout(() => {
      setShowNotification(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [showNotification]);

  return (
    <>
      <Button
        onClick={handleCopy}
        disabled={disabled}
        className={styles.button}
      >
        <span className={styles.copyImage} />
        コピー
      </Button>
      {showNotification && (
        <NotificationToast>
          <div className={styles.toastContent}>生成結果をコピーしました</div>
        </NotificationToast>
      )}
    </>
  );
};
